"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const vue_1 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const vue_router_1 = require("vue-router");
const vuex_1 = require("vuex");
const seo_1 = require("@/hooks/seo");
const uniframe_1 = require("@/hooks/uniframe");
const Default_1 = __importDefault(require("@/layout/Default"));
const Exchange_1 = __importDefault(require("@/layout/Exchange"));
const Mobile_1 = __importDefault(require("@/layout/Mobile"));
const element_locales_1 = require("@/locales/element-locales");
const monitor_1 = require("@/utils/monitor");
const sensors_1 = require("@/utils/sensors");
// import GlobalSetting from '@/components/global/Setting';
const balance_1 = require("@/hooks/balance");
exports.default = {
  setup() {
    const {
      locale,
      messages
    } = (0, vue_i18n_1.useI18n)({
      useScope: 'global'
    });
    const elLocale = (0, vue_1.computed)(() => (0, element_locales_1.getElementLocale)(locale.value || 'en'));
    const route = (0, vue_router_1.useRoute)();
    const store = (0, vuex_1.useStore)();
    const layout = (0, vue_1.computed)(() => route.meta.layout || '');
    const uniFrame = (0, uniframe_1.useUniFrame)();
    let timer = null;
    (0, seo_1.useSEO)();
    if (!window.sfe.prerender) {
      /**
       * 统一账户之间是 user/INIT 和 balance/INIT 异步并行逻辑。代码如下：
       * - dispatch('user/INIT')
       * - store.dispatch('balance/INIT')
       *
       * 统一账户之后 balance 相关的请求需要依赖于 user.getter['isUTA']
       * 所以把 dispatch('user/INIT') 和 store.dispatch('balance/INIT') 改为异步串行逻辑
       */
      store.dispatch('user/INIT').then(() => store.dispatch('balance/INIT'));
      // 用户统一账户资产
      (0, balance_1.useUnifiedBalance)();
      uniFrame.init();
    } else {
      (0, vue_1.onMounted)(() => {
        // 设置定时器在一分钟内去查询local和message是否匹配，匹配后才去预渲染，此时页面多语言已翻译
        // 如果再一分钟内没有匹配到，不再等待，直接进行预渲染，此时预渲染的页面词条显示是错误的，仍然是词条key，没有进行翻译
        const starDate = Date.now();
        timer = setInterval(() => {
          const currDate = Date.now();
          if (currDate - starDate >= 1000 * 60) {
            document.dispatchEvent(new Event('render-event'));
            clearInterval(timer);
          } else {
            const mesValues = Object.keys(messages.value);
            if (mesValues.length > 0 && mesValues.indexOf(locale.value) > -1) {
              document.dispatchEvent(new Event('render-event'));
              clearInterval(timer);
            }
          }
        }, 1000);
      });
    }
    // 绑定更新
    (0, vue_1.watch)(() => locale.value, () => {
      store.dispatch('settings/INIT_LEGAL');
    });
    (0, vue_1.watch)(() => route.meta.layout, () => {
      document.documentElement.setAttribute('data-layout', route.meta.layout);
      document.body.setAttribute('data-layout', route.meta.layout);
    });
    (0, vue_1.watch)(() => route.meta.fixed_header, () => {
      document.documentElement.setAttribute('fixed-header', route.meta.fixed_header);
    });
    // 监听是否需要获取kyc信息
    (0, vue_1.watch)(() => store.getters['user/isLogin'] && route.meta.needKyc, val => {
      if (val) store.dispatch('user/GET_KYC_INFO');
    }, {
      immediate: true
    });
    const methods = {
      // 监听页面隐藏显示设置状态
      visibilityChange() {
        store.commit('settings/SET_PAGE_STATUS', {
          type: 'show',
          status: document.hidden,
          ts: Date.now()
        });
      },
      online(ev) {
        store.commit('settings/SET_PAGE_STATUS', {
          type: 'online',
          status: ev.type === 'online',
          ts: Date.now()
        });
      }
    };
    (0, vue_1.onMounted)(() => {
      document.addEventListener('visibilitychange', methods.visibilityChange, false);
      window.addEventListener('online', methods.online, false);
      window.addEventListener('offline', methods.online, false);
    });
    (0, vue_1.onBeforeUnmount)(() => {
      document.removeEventListener('visibilitychange', methods.visibilityChange, false);
      window.removeEventListener('online', methods.online, false);
      window.removeEventListener('offline', methods.online, false);
    });
    // 非预渲染时初始化天网，不能在 `onload` 事件，因为有其他数据要向天网里推送
    if (!window.sfe.prerender) {
      (0, monitor_1.init)();
      (0, sensors_1.init)();
    }
    // 删除整体 Loading 占位
    try {
      const el = document.querySelector('.root-placeholder-loading');
      el.style.opacity = '0';
      el.style.zIndex = '-999';
      el.style.overflow = 'hidden';
      // if (el) el.parentElement.removeChild(el);
    } catch (e) {} // eslint-disable-line
    return {
      elLocale,
      layout
    };
  },
  components: {
    Default: Default_1.default,
    Exchange: Exchange_1.default,
    Mobile: Mobile_1.default
    // GlobalSetting,
  }
};